(function(){
  if (window.__hbhTabsDesktopInit) return;
  window.__hbhTabsDesktopInit = true;
  var mq = window.matchMedia('(min-width: 990px)');
  function singleOpen(activeTrigger){
    var wrap = activeTrigger.closest('.hbh-tabs__wrap');
    if (!wrap) return;
    var triggers = wrap.querySelectorAll('.hbh-tabs__trigger');
    triggers.forEach(function(btn){
      var isActive = btn === activeTrigger;
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (panel) panel.classList.toggle('is-open', isActive);
    });
  }
  function ensureOneOpen(wrap){
    var openPanels = wrap.querySelectorAll('.hbh-tabs__panel.is-open');
    if (openPanels.length === 0) {
      var firstTrigger = wrap.querySelector('.hbh-tabs__trigger');
      if (firstTrigger) singleOpen(firstTrigger);
    } else if (openPanels.length > 1) {
      var firstOpenTrigger = wrap.querySelector('.hbh-tabs__trigger[aria-expanded="true"]');
      if (firstOpenTrigger) singleOpen(firstOpenTrigger);
    }
  }
  function applyDesktop(){
    document.querySelectorAll('.hbh-tabs__wrap').forEach(ensureOneOpen);
  }
  function attach(){
    document.addEventListener('click', function(e){
      if (!mq.matches) return;
      var trigger = e.target.closest('.hbh-tabs__trigger');
      if (!trigger) return;
      e.stopPropagation();
      requestAnimationFrame(function(){ singleOpen(trigger); });
    }, true);
    mq.addEventListener('change', function(e){ if (e.matches) applyDesktop(); });
    if (mq.matches) applyDesktop();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();